import { Toaster as Sonner } from 'sonner'

import type { IToastProps } from './Toast.types'
import * as S from './Toast.styles'

export const Toast = ({
    position = 'bottom-right',
    expand = false,
    richColors = true,
    closeButton = true,
    duration = 3000,
}: IToastProps) => {
    return (
        <S.ToastWrapper>
            <Sonner
                position={position}
                expand={expand}
                richColors={richColors}
                closeButton={closeButton}
                duration={duration}
            />
        </S.ToastWrapper>
    )
}
